import React from 'react';
import ContactForm from '../ContactFrom'
import './style.css'
const Contactpage = () => {
    return (
        <div id="Contact" className="contact-area section-padding">
            <div className="container">
                <div className="contact-content">
                    <h2>Send a Message</h2>
                    <div className="contact-form">
                        <ContactForm />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Contactpage;